var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 18.5C18 13.75 20.67 8.71998 25.41 7.26998C28.94 6.18998 32.62 7.39998 34.87 10.05C34.8 9.72998 34.73 9.41998 34.63 9.09998C32.56 2.30998 25.4 -1.51002 18.63 0.569978C11.86 2.63998 8.05001 9.82998 10.12 16.61C12.19 23.39 19.35 27.22 26.12 25.14C26.43 25.04 26.74 24.92 27.04 24.81C23.59 24.42 20.53 22.04 19.45 18.5Z",
    fill: "#424895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.01 17.42C25.71 15.98 22.12 16.19 19.13 17.66C20.15 17.69 21.19 17.9 22.19 18.34C26.35 20.16 28.26 25.01 26.45 29.19C24.64 33.37 19.79 35.2799 15.63 33.4599C14.67 33.0399 13.84 32.46 13.13 31.76C14.12 34.9 16.39 37.61 19.64 39.02C25.59 41.62 32.51 38.8799 35.1 32.9199C37.68 26.9499 34.96 20.01 29.01 17.42Z",
    fill: "#96C121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 13.9904C17.53 14.9704 18.53 16.2104 19.21 17.5804C18.95 15.7704 18.01 14.0604 16.44 12.8804C14.38 11.3304 11.75 11.0804 9.52002 11.9804C11.84 11.8404 14.22 12.4904 16.23 13.9904Z",
    fill: "#E50074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 17.58C19.46 19.38 19.04 21.28 17.86 22.85C15.51 26 11.06 26.64 7.91999 24.28C4.77999 21.92 4.13999 17.46 6.49999 14.31C7.30999 13.23 8.35999 12.46 9.51999 11.99C6.65999 12.17 3.87999 13.55 2.02999 16.04C-1.33001 20.54 -0.420013 26.91 4.05999 30.28C8.53999 33.65 14.9 32.74 18.26 28.24C20.64 25.05 20.87 20.92 19.21 17.58Z",
    fill: "#E50074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 23.5202C14.7 20.8602 16.72 18.8502 19.13 17.6602C15.88 17.5702 12.75 19.4302 11.37 22.6102C9.97996 25.8202 10.79 29.4302 13.13 31.7602C12.31 29.1402 12.38 26.2302 13.55 23.5202Z",
    fill: "#96C121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.61 13.2397C36.24 12.0297 35.64 10.9497 34.87 10.0497C36.26 16.2297 32.93 22.5097 27.04 24.8097C28.22 24.9397 29.45 24.8397 30.65 24.4697C35.39 23.0197 38.05 17.9897 36.61 13.2397Z",
    fill: "#424895"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcds);
export default __webpack_public_path__ + "static/media/ecds.9c75c4d63bf4bd455aa1b4de94b457d5.svg";
export { ForwardRef as ReactComponent };